import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';
import { CreateWoundDialogComponent } from './create-wound-dialog/create-wound-dialog.component';
import { WoundCareWidgetWoundListComponent } from './wound-care-widget-wound-list/wound-care-widget-wound-list.component';
import { WoundCareWidgetService } from './wound-care-widget.service';
function getRandom(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

@Component({
  selector: 'app-wound-care-widget',
  templateUrl: './wound-care-widget.component.html',
  styleUrls: ['./wound-care-widget.component.css']
})
export class WoundCareWidgetComponent implements OnInit {

  @Input() provider;
  @Input() note;
  @Input() patient;
  @Input() woundStateCounts: any;
  @Input() readOnlyMode: any;
  activeCount = 0;
  remissionCount = 0;
  amputatedCount = 0;
  archiveCount = 0;
  stateSubscription: any;
  @Output() onICDsSave: EventEmitter<any> = new EventEmitter();
  @Output() woundDetailsChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(WoundCareWidgetWoundListComponent) woundCareWidgetWoundListComponent: WoundCareWidgetWoundListComponent;

  constructor(
    private dialog: MatDialog,
    private woundCareWidgetService: WoundCareWidgetService
  ) { }

  ngOnInit(): void {
    if(this.readOnlyMode == null){
      this.readOnlyMode = false;
    }
    if(this.woundStateCounts){
      this.activeCount = this.woundStateCounts.activeCount;
      this.remissionCount = this.woundStateCounts.remissionCount;
      this.amputatedCount = this.woundStateCounts.amputatedCount;
      this.archiveCount = this.woundStateCounts.archiveCount;
    }else{
      this.woundCareWidgetService.getAllWoundsParentStatesCount(this.patient.patient_id).toPromise().then((res: any) => {
        if (res.status == 200) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i]._id == 'active') {
              this.activeCount = res.data[i].count;
            }
            if (res.data[i]._id == 'remission') {
              this.remissionCount = res.data[i].count;
            }
            if (res.data[i]._id == 'amputated') {
              this.amputatedCount = res.data[i].count;
            }
            if (res.data[i]._id == 'archived') {
              this.archiveCount = res.data[i].count;
            }
          }
        }
      });
    }
    if (this.patient) {
      this.stateSubscription = this.woundCareWidgetService.castState.subscribe((res) => {
        if (res) {
          this.woundCareWidgetService.getAllWoundsParentStatesCount(this.patient.patient_id).toPromise().then((res: any) => {
            if (res.status == 200) {
              this.activeCount = 0;
              this.amputatedCount = 0;
              this.archiveCount = 0;
              this.remissionCount = 0;
              for (let i = 0; i < res.data.length; i++) {
                if (res.data[i]._id == 'active') {
                  this.activeCount = res.data[i].count;
                }
                if (res.data[i]._id == 'remission') {
                  this.remissionCount = res.data[i].count;
                }
                if (res.data[i]._id == 'amputated') {
                  this.amputatedCount = res.data[i].count;
                }
                if (res.data[i]._id == 'archived') {
                  this.archiveCount = res.data[i].count;
                }
              }
              this.woundCareWidgetService.setState(false);
            }
          });
        }
      });
    }
  }
  ngOnDestroy(): void {
    if (this.stateSubscription) {
      this.stateSubscription.unsubscribe();
    }
  }
  updateWoundfromNote(id, data){
    this.woundCareWidgetWoundListComponent.updateWoundfromNote(id,data);
  }
  async showWoundCreateDialog() {
    const wounDataset = await lastValueFrom(this.woundCareWidgetService.getAllDataset(this.provider.company_id));
    console.log(wounDataset);
    const dialogRef = this.dialog.open(CreateWoundDialogComponent, {
      width: 'auto',
      data: wounDataset.data
    });
    dialogRef.afterClosed().subscribe(async (data) => {
    });
  }
  handleICDsSave(icds) {
    console.log('wound-care-widget > handleICDsSave')
    this.onICDsSave.emit(icds);
  }
  handleWoundDetailsChange(data) {
    this.woundDetailsChange.emit(data);
  }
  onTabChanged($event: any) {
    this.woundCareWidgetService.getAllWoundsParentStatesCount(this.patient.patient_id).toPromise().then((res: any) => {
      if (res.status == 200) {
        this.woundCareWidgetService.setState(false);
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i]._id == 'active') {
            this.activeCount = res.data[i].count;
          }
          if (res.data[i]._id == 'remission') {
            this.remissionCount = res.data[i].count;
          }
          if (res.data[i]._id == 'amputated') {
            this.amputatedCount = res.data[i].count;
          }
          if (res.data[i]._id == 'archived') {
            this.archiveCount = res.data[i].count;
          }
        }
      }
    });
  }
  refreshWounds(){
    this.woundCareWidgetWoundListComponent.initWounds();
  }
  handlewoundCountChange($event){
    this.activeCount = $event.activecount;
    this.archiveCount = $event.archivedcount;
  }
}
